export var LoaderVariant;
(function (LoaderVariant) {
    LoaderVariant["Horizontal"] = "horizontal";
    LoaderVariant["Spinner"] = "spinner";
})(LoaderVariant || (LoaderVariant = {}));
//# sourceMappingURL=loader.enum.js.map
